var render, staticRenderFns
import script from "./JourneyBuilderComposerDraggable.vue?vue&type=script&lang=js&"
export * from "./JourneyBuilderComposerDraggable.vue?vue&type=script&lang=js&"
import style0 from "./JourneyBuilderComposerDraggable.vue?vue&type=style&index=0&id=4eb93cb7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb93cb7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4eb93cb7')) {
      api.createRecord('4eb93cb7', component.options)
    } else {
      api.reload('4eb93cb7', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyBuilderComposerDraggable.vue"
export default component.exports